var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinancialReportingFocus(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "240px",
    height: "156px",
    viewBox: "0 0 240 156",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FinancialReporting_newFocus") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.13193,6.14 L29.91193,8.66 C28.83193,7.67 27.90193,7.16 26.64193,7.16 C25.20193,7.16 24.42193,7.73 24.42193,9.08 C24.42193,11.93 32.34193,11.69 32.34193,17.42 C32.34193,20.3 30.75193,22.52 27.66193,23.18 L27.66193,26.3 L24.75193,26.3 L24.75193,23.3 C22.98193,23.09 20.88193,22.31 19.47193,21.02 L21.39193,18.05 C22.92193,19.19 24.24193,19.79 25.68193,19.79 C27.36193,19.79 28.11193,19.1 28.11193,17.72 C28.11193,14.63 20.19193,14.69 20.19193,9.29 C20.19193,6.35 21.93193,4.31 24.75193,3.74 L24.75193,0.65 L27.66193,0.65 L27.66193,3.68 C29.58193,3.95 30.96193,4.91 32.13193,6.14 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FinancialReporting_newFocus"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lv2_Icon_Frame_focus"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Frame_focus"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#A48923",
    x: 0,
    y: 0,
    width: 240,
    height: 156,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#1A4480",
    x: 8,
    y: 7.8,
    width: 224,
    height: 140.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon_FinancialR_static",
    transform: "translate(21.000000, 27.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(123.500000, 6.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#1A4480",
    x: 6.38775373,
    y: 6.38775373,
    width: 67.0714141,
    height: 83.8392676
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#1A4480",
    x: 3.19387686,
    y: 3.19387686,
    width: 67.0714141,
    height: 83.8392676
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 67.0714141,
    height: 83.8392676
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(130.500000, 10.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#4B76B8",
    x: 0,
    y: 29,
    width: 23,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    fill: "#4B76B8",
    x: 0,
    y: 41,
    width: 23,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-12",
    fill: "#4B76B8",
    x: 0,
    y: 53,
    width: 23,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-13",
    fill: "#4B76B8",
    x: 0,
    y: 65,
    width: 23,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#4B76B8",
    x: 29,
    y: 29,
    width: 23,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    fill: "#4B76B8",
    x: 29,
    y: 41,
    width: 23,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-12",
    fill: "#4B76B8",
    x: 29,
    y: 53,
    width: 23,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-13",
    fill: "#4B76B8",
    x: 29,
    y: 65,
    width: 23,
    height: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "$"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000000",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#1A4480",
    xlinkHref: "#path-1"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M108.496297,46.178569 L105.575002,38.0145967 L130.602478,50.178569 L105.575002,62.3425413 L108.496297,54.178569 L94.5,54.178569 L94.5,46.178569 L108.496297,46.178569 Z",
    id: "Combined-Shape",
    stroke: "#FFFFFF",
    fill: "#4B76B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.0974396,27.6761346 L2.0974396,32.4011936 C2.0790907,32.8482533 2.5668273,33.2219206 3.1887031,33.2372378 L92.829134,33.2372378 C93.451009,33.2219206 93.938746,32.8482533 93.920397,32.4011936 L93.920397,27.6761346 C93.931464,27.232697 93.445796,26.8647946 92.829134,26.8494841 L3.1821685,26.8494841 C2.5680846,26.8672856 2.0862826,27.234457 2.0974396,27.6761346 L2.0974396,27.6761346 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.694263,87.91164 L3.694263,83.960772 C3.6889396,83.852621 3.7388349,83.747302 3.8327876,83.668372 C3.9267397,83.589444 4.0569091,83.543492 4.194176,83.540798 L91.823661,83.540798 C91.960928,83.543492 92.091097,83.589444 92.185049,83.668372 C92.279002,83.747302 92.328897,83.852621 92.323573,83.960772 L92.323573,87.91164 C92.328897,88.019791 92.279002,88.12511 92.185049,88.20404 C92.091097,88.282969 91.960928,88.32892 91.823661,88.331614 L4.194176,88.331614 C4.0569091,88.32892 3.9267397,88.282969 3.8327876,88.20404 C3.7388349,88.12511 3.6889396,88.019791 3.694263,87.91164 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6407286,41.4551906 L31.6407286,36.9884731 C31.6372556,36.8447997 31.6808659,36.7053382 31.761956,36.6007997 C31.8430455,36.4962612 31.9549654,36.4352188 32.0730683,36.4311147 L39.9906919,36.4311147 C40.1087948,36.4352188 40.2207147,36.4962612 40.3018042,36.6007997 C40.3828943,36.7053382 40.4265045,36.8447997 40.4230316,36.9884731 L40.4230316,41.4551906 C40.4282661,41.6001965 40.3854432,41.7416914 40.3041653,41.847948 C40.2228874,41.9542045 40.1099551,42.0163318 39.9906919,42.0203992 L32.0730683,42.0203992 C31.9538051,42.0163318 31.8408728,41.9542045 31.7595949,41.847948 C31.678317,41.7416914 31.6354941,41.6001965 31.6407286,41.4551906 L31.6407286,41.4551906 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4851723,41.4551906 L8.4851723,36.9884731 C8.4816994,36.8447997 8.5253092,36.7053382 8.6063988,36.6007997 C8.6874878,36.4962612 8.7994069,36.4352188 8.9175089,36.4311147 L16.8415305,36.4311147 C17.0849257,36.443868 17.2747014,36.6922294 17.2674144,36.9884731 L17.2674144,41.4551906 C17.2726618,41.598883 17.2307147,41.7392141 17.1508229,41.8452421 C17.0709309,41.95127 16.9596552,42.0142873 16.8415305,42.0203992 L8.8981506,42.0203992 C8.6572746,41.9994218 8.4740561,41.7486662 8.4851723,41.4551906 L8.4851723,41.4551906 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5001661,97.3118 L0.5001661,92.126935 C0.4927717,91.804987 0.7332192,91.536763 1.0393273,91.525491 L94.984886,91.525491 C95.131399,91.530894 95.269859,91.597321 95.369758,91.710135 C95.469657,91.822951 95.522798,91.972896 95.517472,92.126935 L95.517472,97.3118 C95.522798,97.465839 95.469657,97.615784 95.369758,97.7286 C95.269859,97.841414 95.131399,97.907841 94.984886,97.913244 L1.0393273,97.913244 C0.7332192,97.901972 0.4927717,97.633748 0.5001661,97.3118 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7504223,41.4551906 L78.7504223,36.9884731 C78.7431351,36.6922294 78.932912,36.443868 79.1763087,36.4311147 L87.100376,36.4311147 C87.218479,36.4352188 87.330399,36.4962612 87.411488,36.6007997 C87.492578,36.7053382 87.536188,36.8447997 87.532715,36.9884731 L87.532715,41.4551906 C87.53795,41.6001965 87.495127,41.7416914 87.413849,41.847948 C87.332571,41.9542045 87.219639,42.0163318 87.100376,42.0203992 L79.1763087,42.0203992 C79.0581833,42.0142873 78.946907,41.95127 78.8670145,41.8452421 C78.7871221,41.7392141 78.7451749,41.598883 78.7504223,41.4551906 L78.7504223,41.4551906 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7963358,41.4551906 L54.7963358,36.9884731 C54.7928629,36.8447997 54.8364731,36.7053382 54.9175631,36.6007997 C54.9986525,36.4962612 55.1105722,36.4352188 55.2286751,36.4311147 L63.1527425,36.4311147 C63.2702955,36.4351807 63.3815867,36.4964808 63.4616547,36.6012657 C63.5417226,36.7060506 63.5838647,36.8455495 63.5786289,36.9884731 L63.5786289,41.4551906 C63.5838763,41.598883 63.5419291,41.7392141 63.4620366,41.8452421 C63.3821442,41.95127 63.2708679,42.0142873 63.1527425,42.0203992 L55.2286751,42.0203992 C55.109412,42.0163318 54.9964798,41.9542045 54.915202,41.847948 C54.8339242,41.7416914 54.7911013,41.6001965 54.7963358,41.4551906 L54.7963358,41.4551906 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0816306,80.098752 L10.0816306,44.6639767 C10.2199753,44.4448545 10.3660432,44.3696428 10.5105905,44.443101 L15.2419552,44.443101 C15.3865024,44.3696428 15.5325704,44.4448545 15.6709151,44.6639767 L15.6709151,80.098752 C15.5325704,80.317874 15.3865024,80.393085 15.2419552,80.319628 L10.5105905,80.319628 C10.3660432,80.393085 10.2199753,80.317874 10.0816306,80.098752 L10.0816306,80.098752 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2372378,80.098752 L33.2372378,44.6639767 C33.3754243,44.4448545 33.521325,44.3696428 33.665707,44.443101 L38.3980532,44.443101 C38.5424352,44.3696428 38.6883359,44.4448545 38.8265224,44.6639767 L38.8265224,80.098752 C38.6883359,80.317874 38.5424352,80.393085 38.3980532,80.319628 L33.665707,80.319628 C33.521325,80.393085 33.3754243,80.317874 33.2372378,80.098752 L33.2372378,80.098752 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.346922,80.097566 L80.346922,44.6651627 C80.483289,44.4477147 80.627364,44.3724965 80.769964,44.4443018 L85.513164,44.4443018 C85.655765,44.3686854 85.800001,44.4439882 85.936206,44.6651627 L85.936206,80.097566 C85.800001,80.318739 85.655765,80.394043 85.513164,80.318427 L80.750735,80.318427 C80.614487,80.377255 80.477222,80.302181 80.346922,80.097566 L80.346922,80.097566 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3928451,80.098752 L56.3928451,44.6639767 C56.5311898,44.4448545 56.6772578,44.3696428 56.821805,44.443101 L61.5531697,44.443101 C61.6977169,44.3696428 61.8437849,44.4448545 61.9821296,44.6639767 L61.9821296,80.098752 C61.8437849,80.317874 61.6977169,80.393085 61.5531697,80.319628 L56.821805,80.319628 C56.6772578,80.393085 56.5311898,80.317874 56.3928451,80.098752 L56.3928451,80.098752 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8394144,0.5489101 L11.0172178,23.1102466 C10.9054522,23.184063 10.8555285,23.3129107 10.8917685,23.4340195 C10.9280084,23.5551284 11.0428739,23.6433107 11.1804078,23.6556073 L84.824801,23.6556073 C84.966984,23.6502745 85.088975,23.5618982 85.126292,23.4371908 C85.163608,23.3124832 85.107648,23.1801942 84.987991,23.1102466 L48.1657945,0.5489101 C48.0688511,0.4836966 47.9363578,0.4836966 47.8394144,0.5489101 Z M48.6096713,17.0994228 L48.6096713,18.4628246 L47.2454027,18.4628246 L47.2454027,17.1824125 C46.4193244,17.1569586 45.6116977,16.9537951 44.8889388,16.5896291 L45.3001777,15.0128252 C45.9997146,15.3913376 46.7967216,15.5957944 47.6109484,15.6056086 C48.4007881,15.6056086 48.9164686,15.3092169 48.9164686,14.769784 C48.9164686,14.2303511 48.4725917,13.9398873 47.4412308,13.5842172 C45.9594654,13.0981348 44.9411596,12.3986504 44.9411596,11.1241661 C44.9637758,9.9122214 45.9662763,8.9006778 47.2910959,8.7530324 L47.2910959,7.4904038 L48.648837,7.4904038 L48.648837,8.6759706 C49.3488751,8.6885476 50.0373712,8.8403038 50.6658656,9.1205581 L50.2611544,10.6380837 C49.6450305,10.3432651 48.9601082,10.1867511 48.2637085,10.1816405 C47.3628996,10.1816405 47.0691575,10.5610218 47.0691575,10.9344754 C47.0691575,11.307929 47.5522,11.6635989 48.7336958,12.090403 C50.3851788,12.6831864 51.0509941,13.4004543 51.0509941,14.6097325 C51.0504895,15.8818584 50.0010778,16.9520607 48.6096713,17.0994228 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancialReportingFocus);
export default __webpack_public_path__ + "static/media/FinancialReporting_Focus.83d26d0a1f51c7dedf0a65a3643eb17a.svg";
export { ForwardRef as ReactComponent };